import type { PhotoNavigatorProps } from "./PhotoNavigator.type";

import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Flex, Typography } from "antd";

import "./PhotoNavigator.style.less";

const { Text } = Typography;

const PhotoNavigator = ({
  isLoading,
  currentImageIndex,
  imageTotalCount,
  currentImageName,
  onPreviousImage,
  onNextImage,
}: PhotoNavigatorProps) => {
  return (
    <div className="photo-navigator-wrapper">
      <Flex vertical>
        <Flex justify="center" align="center" gap="small">
          <Button
            data-testid="previous-photo-button"
            onClick={onPreviousImage}
            disabled={isLoading || currentImageIndex === 0}
            shape="circle"
          >
            <LeftOutlined />
          </Button>

          <Text data-testid="image-index">
            {currentImageIndex + 1}/{imageTotalCount}
          </Text>
          <Button
            data-testid="next-photo-button"
            onClick={onNextImage}
            disabled={isLoading || currentImageIndex === imageTotalCount - 1}
            shape="circle"
          >
            <RightOutlined />
          </Button>
        </Flex>
        <div className="photo-navigator-text">
          <Text className="image-name">{currentImageName}</Text>
        </div>
      </Flex>
    </div>
  );
};

export default PhotoNavigator;
